import Vue from 'vue';
import autofocus from 'vue-autofocus-directive';
import infiniteScroll from 'vue-infinite-scroll';
import TextareaAutosize from 'vue-textarea-autosize';
import Jazzicon from 'vue-jazzicon';
import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import mixins from '@/mixins';
import i18n from '@/i18n';
import '@/auth';
import sitecfg from '@/sitecfg.js';

Vue.use(infiniteScroll);
Vue.use(TextareaAutosize);

// if(!window.process){
//   window.process = {
//     versions: {
//       node: 'kk_mock',
//     }
//   }
// }

// init opensea
// import * as Web3 from 'web3'
// import { OpenSeaPort, Network } from 'opensea-js'
// // const provider = new Web3.providers.HttpProvider('https://mainnet.infura.io')
// const provider = typeof window.web3 !== 'undefined'
//   ? window.web3.currentProvider
//   : new Web3.providers.HttpProvider('https://mainnet.infura.io')
// const seaport = new OpenSeaPort(provider, {
//   networkName: Network.Main
// })
// window._seaport = seaport
// console.log('_seaport for reading done.')

// window.web3read = new Web3('https://mainnet.infura.io/v3') //kk

// api
import api from '@/_api/index.js'
Vue.prototype.api = api
if(!window._empty_tepm){
  window._empty_tepm = {}
  window._empty_tepm.api = api
}

// clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
// toast
import Toasted from 'vue-toasted';
Vue.use(Toasted, {
  theme: "toasted-primary", 
	position: "bottom-left", 
	duration : 3000
})


// 注册全局组件
const requireComponent = require.context('@/components', true, /[\w-]+\.vue$/);
requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName);
  const componentName = upperFirst(
    camelCase(fileName.replace(/^\.\//, '').replace(/\.\w+$/, ''))
  );
  Vue.component(componentName, componentConfig.default || componentConfig);
});

// 注册全局组件 _frame _cp 文件夹
const requireComponentFrame = require.context('@/views', true, /[\w-]+\.vue$/);
requireComponentFrame.keys().forEach(fileName => {
  console.log('========')
  if(fileName.indexOf('_frame') <= 0 && fileName.indexOf('_cp') <= 0){
    return
  }
  const componentConfig = requireComponentFrame(fileName);
  const componentName = upperFirst(
    camelCase(fileName.replace(/^\.\//, '').replace(/\.\w+$/, ''))
  );
  Vue.component(componentName, componentConfig.default || componentConfig);
});

// 多语言处理
window.lang = sitecfg.default_lang || 'en'
import web_lang from "./lang/lang.js";
window.web_lang = web_lang;
import langMethods from './lang/index.js'
Vue.prototype.lg = langMethods.lg
Vue.prototype.lgRefer = langMethods.lgRefer

// filter
import filter from './filter/'
for (let key in filter) {
  Vue.filter(key, filter[key])
}


// aws
// var bucketName = 'gonft';
// var bucketRegion = 'ap-northeast-1';
// var IdentityPoolId = 'ap-northeast-1:d6388a11-775f-48f9-9254-0521cd75b655';


var bucketName = 'jgnnft';
var bucketRegion = 'ap-northeast-1';
var IdentityPoolId = 'ap-northeast-1:15a395fd-4c80-4dda-bfdc-5d62d3e2193c';


window.AWS.config.update({
  name: bucketName,
  region: bucketRegion,
  credentials: new window.AWS.CognitoIdentityCredentials({
    IdentityPoolId: IdentityPoolId
  })
});

window.aws_s3 = new window.AWS.S3({
  params: {Bucket: bucketName}
});


Vue.component('jazzicon', Jazzicon);
Vue.mixin(mixins);
Vue.directive('autofocus', autofocus);

Vue.config.productionTip = false;

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app');


